export default __webpack_public_path__ + "static/media/login_bg_right.36ef1923.svg";